import { useMemo } from "react";

import type * as Model from "../../type";

type QueryData = Model.QueryData;

type Props = {
	queryData: QueryData;
	freeTextSearch: string;
};

type Result = {
	queryData: QueryData;
};

export const useFilteredQueryDataByFreeWord = ({ queryData: _queryData, freeTextSearch }: Props): Result => {
	/**
	 * メルマガ配信希望者の予約に絞り込む
	 */
	const filteredQueryDataByFreeText = useMemo(() => {
		if (freeTextSearch === "") return _queryData;

		// freeTextSearch の全ての全角スペースを半角スペースに変換
		// eslint-disable-next-line no-irregular-whitespace
		const replacedFreeTextSearch = freeTextSearch.replaceAll(/　/g, " ");
		// freeTextSearch 先頭と末尾のスペースを削除
		const trimmedFreeTextSearch = replacedFreeTextSearch.trim();
		// freeTextSearch をスペースで分割
		const freeTextSearchArray = trimmedFreeTextSearch.split(" ");

		// _queryData で freeTextSearchArray のいずれかの文字列を含むデータを抽出
		return _queryData.filter((data) => {
			return freeTextSearchArray.some((freeText) => {
				return JSON.stringify(data).match(freeText);
			});
		});
	}, [_queryData, freeTextSearch]);

	return {
		queryData: filteredQueryDataByFreeText,
	};
};
